import { Button, Drawer } from "antd";
import React from "react";
import { AddIcon, NotificationTrashIcon } from "../Icons";

const Notificationdrawer = ({ onClose, drawerActiveTab }) => {

    const exit=()=>{
        onClose()
    }
  return (
    <Drawer
      title="New NDIS Policy Changes Explained"
      placement={"right"}
      onClose={onClose}
      open={drawerActiveTab}
      key={"right"}
      width={1080}
      className="supportPlanDrawer"
    >
      <div className="mainnotificationdrawer">
        <div className="notificationbox">
          <div className="leftsidecontent">
            <div className="mainflexleftcontent">
              <div>Content</div>

              <div>
                <AddIcon />
              </div>
            </div>

            <div className="ndbbox">
              <div className="policyheader">
                New NDIS Policy Changes Explained
              </div>

              <div className="policyparabox">
                <div className="policyheader">Introduction</div>
                <div className="notificationicon">
                  <NotificationTrashIcon />
                </div>
              </div>

              <div className="policyparabox">
                <div className="policyheader">Key Changes at a Glance</div>
                <div className="notificationicon">
                  <NotificationTrashIcon />
                </div>
              </div>

              <div className="policyparabox">
                <div className="policyheader">What This Means for You</div>
                <div className="notificationicon">
                  <NotificationTrashIcon />
                </div>
              </div>
            </div>
          </div>

          <div className="rightsidecontent">
            <div className="rightsidemain">
              New NDIS Policy Changes Explained
            </div>

            <div className="rightsidepara">
              The latest updates to NDIS policies aim to improve accessibility
              and streamline the application process. Read more to see how these
              changes may affect you.
            </div>

            <div className="rightsidepara">
              <div style={{ marginTop: "24px" }} className="rightsidepara">
                In a continued effort to enhance participant experience and
                ensure a more efficient service delivery, the National
                Disability Insurance Scheme (NDIS) has introduced a series of
                policy updates that took effect in early 2025. These changes are
                designed to simplify the application and renewal processes,
                reduce administrative burdens, and promote equitable access for
                all Australians living with disability.
              </div>

              <div style={{ marginTop: "40px" }} className="rightsidemain">
                Key Changes at a Glance
              </div>

              <div>
                <ul style={{ marginTop: "24px" }}>
                  <li>
                    <strong>Streamlined Digital Onboarding:</strong>
                  </li>

                  <div style={{ marginTop: "5px" }} className="rightsidepara">
                    New applicants will now benefit from a streamlined digital
                    onboarding system, which reduces the time and paperwork
                    previously required. A guided online form and clearer
                    eligibility criteria have been introduced to support
                    first-time users
                  </div>
                </ul>
              </div>

              <div>
                <ul style={{ marginTop: "24px" }}>
                  <li>
                    <strong>Faster Plan Approvals:</strong>
                  </li>

                  <div style={{ marginTop: "5px" }} className="rightsidepara">
                    Average plan approval times have been reduced from 90 to 45
                    days, thanks to improved internal workflows and digital
                    automation. This means less waiting and faster access to
                    services for participants.
                  </div>
                </ul>
              </div>

              <div>
                <ul style={{ marginTop: "24px" }}>
                  <li>
                    <strong>Expanded Support Categories:</strong>
                  </li>

                  <div style={{ marginTop: "5px" }} className="rightsidepara">
                    New categories have been added under core supports to
                    include emerging needs such as digital inclusion and mental
                    health services. This reflects feedback from both
                    participants and providers about evolving care demands.
                  </div>
                </ul>
              </div>
            </div>

            <div className="btn">

                <Button onClick={exit} className="cancelbtn">Cancel</Button>
                <Button onClick={exit}  className="continuebtn">Continue</Button> 


            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default Notificationdrawer;
